<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      search_route="/coupons/add"
      :search_title="$t('addNew')"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->
    <main-filter @getResult="setRows" :dateStart="true" :dateEnd="true" />
    <!-- Start Main Section -->
    <main>
      <v-data-table
        class="elevation-1 thumb diff_table"
        :headers="headers"
        :items="rows"
        :search="search"
        :loading="lodaing"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>

        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Image -->
        <template v-slot:[`item.image`]="{ item }">
          <img
            v-if="item.image"
            @click="show_model_1"
            class="image"
            :src="item.image"
          />
          <p v-else>لا يوجد</p>
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
            {{ item.is_active ? $t("titles.yes") : $t("titles.no") }}
          </span>
        </template>

        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon>
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <h3 class="title table-title">{{ $t("titles.promoCode") }}</h3>
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete_selected" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteSelectedConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete_selected = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Add & Delete -->
          <!-- <v-row>
            <v-col cols="12" sm="8">
            
              <v-text-field
                v-model="search"
                :label="$t('table.search')"
                class="mx-4"
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <section class="table-buttons">
            
                <button
                  @click="addItem"
                  to="/promo-code/add"
                  class="button_add_new ml-5"
                >
                  <i class="fas fa-plus"></i>
                  &nbsp; {{ $t('table.addNew') }}
                </button>

                <button
                  type="button"
                  class="button_delete ml-5"
                  v-if="selected.length > 0"
                  @click="deleteSelected"
                >
                  <i class="far fa-trash-alt"></i>
                  &nbsp;
                  {{ $t('table.deleteSelected') }}
                </button>
              </section>
            </v-col>
          </v-row> -->
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!-- End Main Section -->

    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- End Image_Model -->

    <!-- Start Pagination -->
    <template>
      <div
        class="pagination_container text-center mb-5 d-flex justify-content-end"
      >
        <!-- <div class="select-pagination d-flex">
          <span class="first">{{ $t("show") }}</span>
          <v-select
            :items="[5, 20, 50, 100]"
            v-model="paginations.items_per_page"
          ></v-select>
          <span>{{ $t("entries") }}</span>
        </div> -->

        <v-pagination
          v-model.number="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="5"
          @input="fetchData($event)"
        ></v-pagination>
      </div>
    </template>
    <!-- End Pagination -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.coupons.title"),
          disabled: true,
          href: "",
        },
        {
          text: this.$t("breadcrumb.coupons.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      lodaing: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "cenetr",
            value: "id",
            width: "80",
            sortable: true,
          },
          {
            text: "الصورة ",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "الكود", align: "start", value: "code", sortable: false },
          {
            text: "أقصي عدد مرات الاستخدام",
            align: "center",
            value: "max_used_num",
            sortable: false,
          },
          {
            text: "عدد مرات الاستخدام الحالية",
            align: "center",
            value: "num_of_used",
            sortable: false,
          },
          {
            text: "عدد المرات المتبقية",
            align: "center",
            value: "remain_used",
            sortable: false,
          },
          {
            text: "تاريخ البداية",
            align: "start",
            value: "start_at",
            sortable: false,
          },
          {
            text: "تاريخ الإنتهاء",
            align: "start",
            value: "end_at",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "start",
            value: "is_active",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            align: "start",

            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "cenetr",
            value: "id",
            width: "80",
            sortable: true,
          },
          {
            text: "Image ",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Code", align: "start", value: "code", sortable: false },
          {
            text: "Max Num Of Use",
            align: "center",
            value: "max_used_num",
            sortable: false,
          },
          {
            text: "Current Num Of Use",
            align: "center",
            value: "num_of_used",
            sortable: false,
          },
          {
            text: "Reset Num Of Use",
            align: "center",
            value: "remain_used",
            sortable: false,
          },
          {
            text: "Start Date",
            align: "start",
            value: "start_at",
            sortable: false,
          },
          {
            text: "End Date",
            align: "start",
            value: "end_at",
            sortable: false,
          },
          {
            text: "Status",
            align: "start",
            value: "is_active",
            sortable: false,
          },
          {
            text: "Control",
            value: "actions",
            align: "start",

            sortable: false,
          },
        ];
      }
    },
    keyword() {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword;
      }
      return "";
    },
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/coupons/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/coupons/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/coupons/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `coupon/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.$axios({
        method: "POST",
        url: `offer/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows(e) {
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "coupon",
        params: {
          page: this.paginations.current_page,
          keyword: this.keyword,
          start_at: e?.dateStart ? e.dateStart : "",
          end_at: e?.dateEnd ? e.dateEnd : "",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.statisticsItem.number = res.data.meta.total;

          this.rows = res.data.data;

          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>
